/**
 * Hook to get toolbar position
 * 
 * The toolbar is centered horizontally and positioned at a fixed distance from the bottom.
 * The minimap (bottom-right) and quest log (bottom-left) are in the corners, so a centered
 * toolbar doesn't need dynamic repositioning to avoid them.
 */
export const useToolbarPosition = () => {
  // Fixed position - no dynamic calculation needed
  // The toolbar is centered, corner elements don't overlap
  return 24;
};
